// extracted by mini-css-extract-plugin
export default {"activeLink":"sidebarItem_activeLink__5UXm0","activeLinkHovered":"sidebarItem_activeLinkHovered__IgJB1","adminMenu":"sidebarItem_adminMenu__TCGoV"};